export default "__VITE_ASSET__27055ac2__"